module.exports = __webpack_public_path__ + "media/couple-testimonial-02.46791fa5.png";